import React from 'react';
import classes from './Table.module.css';
import TextContent from '../../UI/TextContent';
import { Box, Typography } from '@mui/material';

const excludeTarget = [
    {
        division: '연삭기/연마기',
        list: [
            {
                title: '동력에 의해 회전하는 연삭숫돌 또는 연마재 등을 사용하여 금속이나 그 밖의 가공물의 표면을 깍아내거나 절단 또는 광택을 내기 위해 사용되는 것',
                exclude: ['휴대형은 제외']
            }
        ]
    },
    {
        division: '산업용 로봇',
        list: [
            {
                title: '직교좌표로봇을 포함하여 3축 이상의 메니퓰레이터(엑츄에이터, 교시 펜던터를 포함한 제어기 및 통신 인터페이스를 포함한다)를 구비하고 전용의 제어기를 이용하여 프로그램 및 자동제어가 가능한 고정식 로봇',
                exclude: ''
            }
        ]
    },
    {
        division: '혼합기',
        list: [
            {
                title: '회전축에 고정된 날개를 이용하여 내용물을 저어주거나 섞는 것',
                exclude: [
                    '외통 전체를 회전시켜서 내부의 물질을 섞어주는 용기회전형 혼합기',
                    '분사장치를 이용하여 물질을 섞어주는 기류교반형 혼합기',
                    '혼합용기의 용량이 200리터 미만이거나 모터의 구동력이 1킬로와트 미만인 혼합기',
                    '식품용'
                ]
            }
        ]
    },
    {
        division: '파쇄기 또는 분쇄기',
        list: [
            {
                title: '암석이나 금속 또는 플라스틱 등의 물질을 필요한 크기의 작은 덩어리 또는 분체로 부수는 것',
                exclude: [
                    '식품용',
                    '시간당 파쇄 또는 분쇄용량이 50킬로그램 미만인 것',
                ]
            }
            
        ]
    },
    {
        division: '식품가공용기계',
        list: [
            {
                title: '식품파쇄기 : 채소, 육류, 곡물 또는 어류 등의 식품을 으깨는 것',
                exclude: [
                    '구동모터의 용량이 1.2킬로와트 이하인 것',
                    '가정용으로 사용되는 것'
                ]
            },
            {
                title: '식품절단기 : 채소, 육류, 곡물 또는 어류 등의 식품을 일정 크기로 자르는 것',
                exclude: [
                    '구동모터의 용량이 1.2킬로와트 이하인 것',
                    '가정용으로 사용되는 것'
                ]
            },
            {
                title: '식품혼합기 : 채소, 육류, 곡물 또는 어류 등을 혼합하는 기계',
                exclude: [
                    '외통 전체를 회전시켜서 내부의 물질을 섞어주는 용기회전형 혼합기',
                    '구동모터의 용량이 1.2킬로와트 이하인 것',
                    '가정용으로 사용되는 것'
                ]
            },
            {
                title: '제면기 : 밀가루, 메밀가루 등 분말형태의 곡물을 일정한 길이의 면으로 뽑아내는 기계',
                exclude: [
                    '구동모터의 용량이 1.2킬로와트 이하인 것',
                    '가정용으로 사용되는 것'
                ]
            },
        ]
    },
    {
        division: '컨베이어',
        list: [
            {
                title: '재료·반제품·화물 등을 동력에 의하여 자동적으로 연속 운반하는 것으로서 다음 각 목의 어느 하나에 해당하는 컨베이어',
                refer: [
                    '벨트 또는 체인컨베이어',
                    '롤러 컨베이어',
                    '트롤리 컨베이어',
                    '버킷 컨베이어',
                    '나사 컨베이어'
                ],
                exclude: [
                    '이송거리가 3미터 이하인 컨베이어'
                ]
            }
            
        ]
    },
    {
        division: '자동차정비용 리프트',
        list: [
            {
                title: '하중 적재장치에 차량을 적재한 후 동력을 사용하여 차량을 들어올려 점검 및 정비 작업에 사용되는 장치',
                exclude: ''
            }
            
        ]
    },
    {
        division: '공작기계',
        list: [
            {
                title: '선반: 회전하는 축(주축)에 공작물을 장착하고 고정되어 있는 절삭공구를 사용하여 원통형의 공작물을 가공하는 공작기계',
                exclude: ''
            },
            {
                title: '드릴기: 공작물을 테이블 위에 고정시키고 주축에 장착된 드릴공구를 회전시켜서 축방향으로 이송시키면서 공작물에 구멍가공하는 공작기계',
                exclude: ''
            },
            {
                title: '평삭기: 공작물을 테이블 위에 고정시키고 절삭공구를 수평왕복시키면서 공작 물의 평면을 가공하는 공작기계',
                exclude: ''
            },
            {
                title: '형삭기: 공작물을 테이블 위에 고정시키고 램(ram)에 의하여 절삭공구가 상하 운동하면서 공작물의 수직면을 절삭하는 공작기계',
                exclude: ''
            },
            {
                title: '밀링기: 여러 개의 절삭날이 부착된 절삭공구의 회전운동을 이용하여 고정된 공작물을 가공하는 공작기계',
                exclude: ''
            },
            
        ]
    },
    {
        division: '고정형 목재가공용기계',
        list: [
            {
                title: '둥근톱기계: 고정된 둥근톱 날의 회전력을 이용하여 목재를 절단가공을 하는 기계',
                exclude: ''
            },
            {
                title: '기계대패: 공작물을 이송시키면서 회전하는 대팻날로 평면 깎기, 홈 깎기 또는 모떼기 등의 가공을 하는 기계',
                exclude: ''
            },
            {
                title: '루타기: 고속 회전하는 공구를 이용하여 공작물에 조각, 모떼기, 잘라내기 등의 가공작업을 하는 기계',
                exclude: ''
            },
            {
                title: '띠톱기계: 프레임에 부착된 상하 또는 좌우 2개의 톱바퀴에 엔드레스형 띠톱을 걸고 팽팽하게 한 상태에서 한 쪽 구동 톱바퀴를 회전시켜 목재를 가공 하는 기계',
                exclude: ''
            },
            {
                title: '모떼기기계: 공구의 회전운동을 이용하여 곡면절삭, 곡선절삭, 홈붙이 작업 등에 사용되는 기계',
                exclude: ''
            },
            
        ]
    },
    {
        division: '인쇄기',
        list: [
            {
                title: '판면에 잉크를 묻혀 종이, 필름, 섬유 또는 이와 유사한 재질의 표면에 대고 눌러 인쇄 작업을 하는 기계.',
                refer: [
                    '절단기, 제본기, 종이반전기 등 설비 부속 장치를 포함'
                ],
                exclude: ''
            }
            
        ]
    },
]

const Subul = props => {
    const data = props.data;
    return (
        <ul className={classes['sub-ul']}>
            {            
            data.map((item, index) => (
                <li key={index} className={classes['exclude-list']}><Typography variant="reference" component="p">{item}</Typography></li>
            ))
            }
        </ul>
    )
}

const Table = props => {
    return (
        <TextContent title="대상 기계 별 적용 범위" {...props}>
            <Box className={classes['table-area']}>
                <table className={classes['target-table']}>
                    <colgroup>
                        <col width="10%"/>
                        <col width="20%"/>
                        <col width="70%"/>
                    </colgroup>
                    <thead>
                        <tr>
                            <th><Typography variant="contentTitleSmall" component="p">번호</Typography></th>
                            <th><Typography variant="contentTitleSmall" component="p">기계,기구</Typography></th>
                            <th><Typography variant="contentTitleSmall" component="p">규격 및 형식별 적용범위</Typography></th>
                        </tr>
                    </thead>
                    <tbody>
                        {excludeTarget.map((list, index) => (
                            <tr key={index}>
                                <td><Typography variant="body1" component="p" textAlign='center'>{index+1}</Typography></td>
                                <td><Typography variant="body1" component="p" textAlign='center'>{list.division}</Typography></td>
                                <td>
                                    <ul className={classes['main-ul']}>
                                        {
                                            list.list.map((des,desindex) => (
                                            
                                                <li key={desindex}><Typography variant="contentTitleSmall" component="p">{des.title}</Typography>
                                                    {des.refer && <Subul data={des.refer}/>}

                                                    {des.exclude &&
                                                        <div>
                                                            <p style={{marginTop: '1rem'}}>제외대상</p>
                                                            <Subul data={des.exclude}/>
                                                        </div>
                                                    }
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Box>
        </TextContent>
    )
}

export default Table;
